// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fields-box {
  position: relative;
  line-height: 1.5;
  padding: 3px 5px;
}
.fields-box p {
  margin: 0;
}
.fields-box .badge {
  position: absolute;
  top: 5px;
  left: 5px;
}

.shifts ion-item ion-label span {
  font-weight: bold;
}

ion-card {
  border-radius: 10px;
}

.box-header {
  background: var(--button-a-background);
  color: var(--button-a-text);
  padding: 3px 5px;
}
.box-header .title {
  font-size: 16px;
}

.box-header.warning {
  background: var(--ion-color-warning);
  color: #000;
}

.box-header.primary {
  background: var(--ion-color-primary);
}

.box-header.danger {
  background: var(--ion-color-danger);
}

.badge {
  color: #fff;
  border-radius: 18px;
  padding: 5px 7px;
}

.badge-box {
  height: 25px;
  padding: 1px 0;
}

.details-box {
  display: flex;
  flex-wrap: wrap;
}
.details-box .price-box h1, .details-box .price-box h3 {
  font-weight: bold;
}
.details-box .price-box h1 {
  font-size: 28px;
}
.details-box .price-box ::ng-deep .price-div {
  justify-content: center;
}

.details-box > div {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  padding: 3px 15px;
}
.details-box > div h3, .details-box > div h1, .details-box > div p {
  margin: 0;
}
.details-box > div .flex-row {
  gap: 7px;
}
.details-box > div .title {
  font-size: 10px;
  white-space: nowrap;
  margin-top: 5px;
}

.details-box > div:after {
  height: 80%;
  border-left: 2px solid #ececec;
  content: "";
  position: absolute;
  left: 0;
  top: 10%;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/orders/components/order-box/order-box.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;EACA,gBAAA;AACF;AACE;EACE,SAAA;AACJ;AAEE;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AAAJ;;AAOM;EACE,iBAAA;AAJR;;AAUA;EACE,mBAAA;AAPF;;AAUA;EAEE,sCAAA;EACA,2BAAA;EACA,gBAAA;AARF;AAUE;EACE,eAAA;AARJ;;AAYA;EACE,oCAAA;EACA,WAAA;AATF;;AAYA;EACE,oCAAA;AATF;;AAYA;EACE,mCAAA;AATF;;AAYA;EAEE,WAAA;EACA,mBAAA;EACA,gBAAA;AAVF;;AAaA;EACE,YAAA;EACA,cAAA;AAVF;;AAaA;EACE,aAAA;EAGA,eAAA;AAZF;AAgBI;EACE,iBAAA;AAdN;AAiBI;EACE,eAAA;AAfN;AAmBM;EACE,uBAAA;AAjBR;;AAuBA;EACE,kBAAA;EACA,cAAA;EAGA,aAAA;EACA,sBAAA;EAEA,iBAAA;AAvBF;AA0BE;EACE,SAAA;AAxBJ;AA2BE;EACE,QAAA;AAzBJ;AA4BE;EACE,eAAA;EACA,mBAAA;EACA,eAAA;AA1BJ;;AA8BA;EACE,WAAA;EACA,8BAAA;EAEA,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AA5BF","sourcesContent":[".fields-box {\n  position: relative;\n  line-height: 1.5;\n  padding: 3px 5px;\n\n  p {\n    margin: 0;\n  }\n\n  .badge {\n    position: absolute;\n    top: 5px;\n    left: 5px;\n  }\n}\n\n.shifts {\n  ion-item {\n    ion-label {\n      span {\n        font-weight: bold;\n      }\n    }\n  }\n}\n\nion-card {\n  border-radius: 10px;\n}\n\n.box-header {\n  //margin-top: 10px;\n  background: var(--button-a-background);\n  color: var(--button-a-text);\n  padding: 3px 5px;\n\n  .title {\n    font-size: 16px;\n  }\n}\n\n.box-header.warning {\n  background: var(--ion-color-warning);\n  color: #000;\n}\n\n.box-header.primary {\n  background: var(--ion-color-primary);\n}\n\n.box-header.danger {\n  background: var(--ion-color-danger);\n}\n\n.badge {\n  //margin-top: 5px;\n  color: #fff;\n  border-radius: 18px;\n  padding: 5px 7px;\n}\n\n.badge-box {\n  height: 25px;\n  padding: 1px 0;\n}\n\n.details-box {\n  display: flex;\n  //padding: 5px;\n\n  flex-wrap: wrap;\n  //gap: 7px;\n\n  .price-box {\n    h1, h3 {\n      font-weight: bold;\n    }\n\n    h1 {\n      font-size: 28px;\n    }\n\n    ::ng-deep {\n      .price-div {\n        justify-content: center;\n      }\n    }\n  }\n}\n\n.details-box > div {\n  position: relative;\n  flex: 1 1 auto;\n  //padding: 0 15px;\n\n  display: flex;\n  flex-direction: column;\n  //justify-content: center;\n  padding: 3px 15px;\n\n\n  h3, h1, p {\n    margin: 0;\n  }\n\n  .flex-row {\n    gap: 7px;\n  }\n\n  .title {\n    font-size: 10px;\n    white-space: nowrap;\n    margin-top: 5px;\n  }\n}\n\n.details-box > div:after {\n  height: 80%;\n  border-left: 2px solid #ececec;\n\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 10%;\n}\n\n.details-box > div:last-child:after {\n  //display: none;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
